import { phpApi, handleApiError } from "../../api";

export const getBrands = () => {
  return phpApi.get("/api/brands").catch(handleApiError);
};
